export const divideNameIntoFirstAndLast = (inputStr: string) => {
  const strList = inputStr.match(' ') ? inputStr.split(' ') : [inputStr, '']
  const dividedName = { first: strList[0], last: strList[1] }
  return dividedName
}
